<div class="language-switcher">
    <p-selectbutton
        allowEmpty="false"
        aria-labelledby="basic"
        optionLabel="name"
        optionValue="code"
        [options]="languageList"
        [(ngModel)]="languageSelected"
        (onChange)="switchLanguage($event)" />
</div>
